var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReactWrapper',_vm._b({attrs:{"component":_vm.component},on:{"onChange":_vm.handleChange}},'ReactWrapper',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }